module.exports = __webpack_public_path__ + "static/img/wfdhhzn.43906ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wfdhhzn.jpg
// module id = wlyq
// module chunks = 31